var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-footer',{style:({ textAlign: 'center' })},[_c('div',{staticStyle:{"padding":"10px 144px"}},[_vm._v("\n    备案号：\n    "),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn/","target":"_blank"}},[_vm._v("豫ICP备19037402号")])])])}
var staticRenderFns = []

export { render, staticRenderFns }